import { Component, inject } from "@angular/core";
import { TablerIconComponent } from "angular-tabler-icons";
import { MaterialModule } from "src/app/core/material.module";
import { User } from "src/app/core/models/user.model";
import { UserService } from "src/app/core/services/user.service";

@Component({
  selector: "app-theme-mode",
  standalone: true,
  imports: [MaterialModule, TablerIconComponent],
  templateUrl: "./theme-mode.component.html",
})
export class ThemeModeComponent {
  private userService = inject(UserService);

  userInfo: User = this.userService.getUser();

  get isDarkMode(): boolean {
    return this.userInfo?.Theme === "dark-mode";
  }

  setTheme(mode: "light-mode" | "dark-mode") {
    this.userInfo = this.userService.setTheme(this.userInfo, mode);
  }
}
